import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/containers/GeneralPage.tsx");
